<template>
    <Head title="Termos de Uso" />
    <RegisterLayout title="Termos de Uso" :showLogo="false">
      <div class="px-6">
        <p class="pb-2">Ao usar a nossa plataforma, você está ciente dos seguintes termos de uso:</p>
        <p class="pb-2">Etapa 2/3</p>
      </div>
        <article>
            <div class="sm:px-5 h-[535px] overflow-y-scroll">
                <!-- <HeadingGuest title="Transparência" /> -->
                <!-- <p class="pb-2">Ao usar a nossa plataforma, você está ciente dos seguintes termos de uso:</p> -->
                <form @submit.prevent="submit">
                    <ul class="grid gap-5 pt-4">
                        <li class="py-6 px-4 bg-gray-100">
                            <div v-html="term.text">

                            </div>
                            <!-- <PrivacyMockado /> -->
                        </li>
                        <div class="flex" v-for="(termsAccept, index) in term.termAccepts" :key="index">
                            <input class="hover:bg-gray-600 self-start mt-1 mr-2" type="radio" :id="'acceptTerms-' + index " :name="'acceptTerms-' + index " :value="termsAccept.id" v-model="acceptTerms[termsAccept.id]">
                            <label  :for="'acceptTerms-' + index ">{{ termsAccept.text }}</label>
                        </div>

                        <li>
                            <Button
                                @click.prevent="submit()"
                                :enabled="allIsValid"
                            >
                                Avançar
                            </Button>
                        </li>
                    </ul>
                </form>
            </div>
        </article>
        <ValidationErrors :errors="errors" />
  </RegisterLayout>
</template>

<script>
import PrivacyMockado from '@/Components/PrivacyMockado.vue'
import Input from "@/Components/UI/Form/Input.vue";
import Select from "@/Components/Select.vue"
import Button from "@/Components/Button.vue";
import RegisterLayout from "@/Layouts/Register.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue";

export default {

  components: {
    Input,
    Label,
    ValidationErrors,
    Head,
    Link,
    Select,
    RegisterLayout,
    HeadingGuest,
    PrivacyMockado,
    Button
  },

   props: {
    term: Object,
    acceptTerms: {
      type: Object,
      default: {}
    },
  },

  data() {
    return {
      form: this.$inertia.form({
        // cpf: sessionStorage.getItem("cpf"),
        // name: sessionStorage.getItem("name"),
        // email: sessionStorage.getItem("email"),
        // password: sessionStorage.getItem("password"),
        // birthDate: sessionStorage.getItem("birthDate"),
        // username: sessionStorage.getItem("username"),
        // nickname: sessionStorage.getItem("nickname"),
        // acceptRegulamento: sessionStorage.getItem("acceptRegulamento"),
        acceptTerm: ''
      }),
      errors: []
    };
  },

  computed: {
      allIsValid: function() {
        const terms = JSON.parse(
            JSON.stringify(this.acceptTerms)
        );

        return Object.values(terms).filter(accepted => !accepted).length === 0
      }
  },

  methods: {
    submit() {
        this.errors = [];

        const terms = JSON.parse(
            JSON.stringify(this.acceptTerms)
        );

        if(Object.values(terms).filter(accepted => !accepted).length === 0) {

            sessionStorage.setItem('acceptTerm', JSON.stringify(this.acceptTerms));
            this.$inertia.get("/register/privacidade");
        } else {
            this.errors.push('Aceite os termos para prosseguirmos')
        }
    },
  },
};
</script>
